import React from 'react';
import styled from 'styled-components/macro';
import {
  Heading1, LinkStyled, Hr,
} from '../components/typography';
import { Container, Row, Col } from '../components/grid';
import getSitemap from '../routes/sitemap';
import FullWidthLayout from '../layout/DefaultLayout/Layouts/FullWidthLayout';

const SitemapList = styled.ul`
  & > li {
    & ul {
      margin:0 0 0 1em; /* indentation */
      padding:0;
      list-style:none;
      color:#369;
      position:relative;
    }
  
    & ul {margin-left:.5em} /* (indentation/2) */
  
    & ul:before {
      content:"";
      display:block;
      width:0;
      position:absolute;
      top:0;
      bottom:0;
      left:0;
      border-left:1px solid;
    }
  
    & li {
      margin:0;
      padding:0 1.5em; /* indentation + .5em */
      line-height:2em; /* default list item's line-height */
      font-weight:bold;
      position:relative;
    }
  
    & li:before {
      content:"";
      display:block;
      width:10px; /* same with indentation */
      height:0;
      border-top:1px solid;
      margin-top:-1px; /* border top width */
      position:absolute;
      top:1em; /* (line-height/2) */
      left:0;
    }
  
    & li:last-child:before {
      background:white; /* same with body background */
      height:auto;
      top:1em; /* (line-height/2) */
      bottom:0;
    }
  }
`;

const FlexWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const RenderElement = ({
  title,
  link,
  metaTitle,
  children = [],
}) => {
  let childrenElements = null;
  if (children.length > 0) {
    childrenElements = (
      <ul>
        {children.map(
          (element) => {
            const { link } = element;
            return <RenderElement key={link} {...element} />;
          },
        )}
      </ul>
    );
  }
  return (
    <li>
      <LinkStyled to={link} title={metaTitle}>{title}</LinkStyled>
      {childrenElements}
    </li>
  );
};
export default class Sitemap extends React.Component {
  constructor(props) {
    super(props);
    this.sitemap = getSitemap();
    // console.log('What is sitemap??', this.sitemap);
  }

  render() {
    const { sitemap } = this;
    return (
      <FullWidthLayout>
        <Container white>
          <Row>
            <Col xs={12}>
              <Heading1>Sitemap</Heading1>
              <Hr />
              <FlexWrap>
                <SitemapList>
                  {sitemap.children.map(
                    (element) => {
                      const {
                        link,
                      } = element;
                      return <RenderElement {...element} key={link} />;
                    },
                  )}
                </SitemapList>
              </FlexWrap>
            </Col>
          </Row>
        </Container>
      </FullWidthLayout>
    );
  }
}
